import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight, Calculator } from "lucide-react";
import { PACKAGES } from "@/lib/packages";

const CASES = [
  { label: "Formiche o ragni in casa", credits: 1 },
  { label: "Pesciolini d'argento", credits: 1 },
  { label: "Scarafaggi / blatte in cucina", credits: 1 },
  { label: "Vespe o calabroni (nido singolo)", credits: 1 },
  { label: "Mosche", credits: 2 },
  { label: "Termiti", credits: 2 },
  { label: "Pulci", credits: 2 },
  { label: "Zecche", credits: 2 },
  { label: "Allontanamento volatili", credits: 2 },
  { label: "Cimici dei letti", credits: 2 },
  { label: "Topi / roditori in casa o cantina", credits: 2 },
  { label: "Infestazione completa villa + giardino", credits: 2 },
  { label: "Esigenza urgente, anche nei weekend", credits: 5 },
];

const TIER_BY_CREDITS = { 1: "Voucher Base", 2: "Voucher Premium", 5: "Voucher VIP" };
const PKG_BY_CREDITS = { 1: "single", 2: "premium", 5: "business" };

export const CreditCalculator = ({ onSelect }) => {
  const [selected, setSelected] = useState("");
  const found = CASES.find((c) => c.label === selected);

  return (
    <section className="max-w-6xl mx-auto px-6 py-24">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="rounded-[2rem] bg-tint border border-line p-8 sm:p-12"
      >
        <div className="flex items-center gap-3 mb-6">
          <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-moss">
            <Calculator size={20} className="text-gold" />
          </div>
          <h2 className="font-serif text-2xl sm:text-3xl tracking-tight text-moss">
            Quale voucher fa per te?
          </h2>
        </div>
        <label htmlFor="credit-simulator" className="block text-sm font-medium text-sub mb-2">
          Seleziona il tuo problema
        </label>
        <select
          id="credit-simulator"
          data-testid="credit-simulator-input"
          value={selected}
          onChange={(e) => setSelected(e.target.value)}
          className="w-full max-w-xl rounded-2xl border border-line bg-white px-5 py-4 text-base text-ink focus:outline-none focus:ring-2 focus:ring-moss/40"
        >
          <option value="">— Scegli dalla lista —</option>
          {CASES.map((c) => (
            <option key={c.label} value={c.label}>
              {c.label}
            </option>
          ))}
        </select>
        <AnimatePresence mode="wait">
          {found && (
            <motion.div
              key={found.label}
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -8 }}
              transition={{ duration: 0.35 }}
              className="mt-6 flex flex-wrap items-center gap-5"
            >
              <button
                onClick={() => onSelect(PACKAGES.find((p) => p.id === PKG_BY_CREDITS[found.credits]))}
                data-testid="credit-simulator-result"
                className="rounded-2xl bg-moss px-6 py-4 text-left cursor-pointer transition-all duration-200 hover:bg-mosslight hover:-translate-y-0.5 hover:shadow-[0_14px_30px_rgba(27,59,43,0.25)]"
              >
                <p className="font-serif text-3xl font-bold text-gold leading-none">
                  {TIER_BY_CREDITS[found.credits]}
                </p>
                <p className="mt-1.5 text-xs text-alabaster/70">
                  consigliato per {found.label.toLowerCase()} — tocca per acquistare
                </p>
              </button>
              <button
                onClick={() => onSelect(PACKAGES.find((p) => p.id === PKG_BY_CREDITS[found.credits]))}
                data-testid="credit-simulator-cta"
                className="inline-flex items-center gap-2 rounded-full bg-terracotta px-6 py-3.5 text-sm font-semibold text-alabaster transition-all duration-200 hover:bg-terrahover hover:-translate-y-0.5"
              >
                Acquista ora — {PACKAGES.find((p) => p.id === PKG_BY_CREDITS[found.credits])?.priceGross}
                <ArrowRight size={16} />
              </button>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>
    </section>
  );
};
